

/* Constants for FB messenger related components */

module.exports = {
    OVERRIDE_FBPP_REPEAT_FLAG: 'override_fbpp_repeat',
    OVERRIDE_FBPP_MOBILE_FLAG: 'override_fbpp_mobile',
    FB_BA_SHOWN_FLAG: 'is_xo_wps_fb_messenger_plugin_match_withba_shown',
    MOBILE_CHANNEL: 'MOBILE',
    WEB_CHANNEL: 'WEB',
    FB_USER_API_MOBILE_URL: 'https://m.facebook.com/paypal/user_identifier',
    FB_USER_API_URL: 'https://www.facebook.com/paypal/user_identifier',
    FB_PROD_APP_ID: '1084613224964631',
    FB_PROD_PAGE_ID: '55982004572',
    FB_TEST_PAGE_ID: '676472402496128',
    PXP_MESSENGER_EXPT: 'xo_wps_fb_messenger_plugin',
    PXP_SHOW_MESSENGER_PLUGIN_TREATMENT: 'xo_wps_fb_messenger_plugin_1_treatment',
    PXP_SHOW_FB_BA_TREATMENT: 'xo_wps_fb_messenger_plugin_match_withba'
};


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/constants/fbMessenger.js
// module id = ./components/xo-page-components/src/constants/fbMessenger.js
// module chunks = 1